import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UserInput from '../components/UserInput';
import AccountButton from '../components/AccountButton';
import Divider from '../components/Divider';
import '../components/SignIn.css';
import { InputContext } from '../components/InputContext';

const baseURL = process.env.REACT_APP_API_URL;


const CreateAcc = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [verifyPassword, setVerifyPassword] = useState('');
  const { setGlobalUser } = useContext(InputContext);

  const handleCreateAcc = (e) => {
    e.preventDefault(); 

    if (!username || !password) {
      alert('Missing username and/or password.');
      return;
    } 
    else if (password !== verifyPassword) { 
      alert('Passwords do not match.');
      return;
    }
    
    fetch(`${baseURL}/acc/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    })
    .then(res => res.json())
    .then(data => {
      if (data.error) {
        alert(data.error);
      } 
      else {
        setGlobalUser(data.username);
        navigate('/home');
      }
    })
    .catch(err => {
      console.error('Registration error:', err);
      alert('Account creation failed. Try again.');
    });
  };

  return (
    <div className="signin-container">
      <div className="title">RecipeShare</div>

      <div className="signin-box">
        <h2>Register</h2>
        <form>
          <UserInput type="text" placeholder="Username" 
            value={username} onChange={(e) => setUsername(e.target.value)}/>
          <UserInput type="password" placeholder="Password"
            value={password} onChange={(e) => setPassword(e.target.value)}/>
          <UserInput type="password" placeholder="Re-enter Password" 
            value={verifyPassword} onChange={(e) => setVerifyPassword(e.target.value)}/>
          <AccountButton text="Create Account" onClick={handleCreateAcc}/>
        </form>
        
        <Divider/>
        <AccountButton text="Go Back" create onClick={() => navigate(-1)}/>
      </div>
    </div>
  );
};

export default CreateAcc;
